import { FC } from 'react'
import _ from 'lodash'
import { useTranslation } from 'react-i18next'
import { AccentDescription, StatusDescription } from '../../../styled'
import { InputWrapper, TextWrapper } from '../../styled'
import { refetchFunc } from 'modules/domain/common/hooks'
import { apiClient } from 'modules/utils/httpClient'
import { endpoints } from 'modules/endpoints'
import { useFormik } from 'formik'
import { useAFormHandler } from 'analytics/hooks'
import { FormInput } from 'views/components/form/FormInput'
import PermissionCheck from 'views/components/PermissionCheck/PermissionCheck'
import { AButton } from 'views/components/Analytics'
import { ShortFormControls } from 'views/styled/common'

export const TurnoverDaysStep: FC<{
  plannedTurnoverDays: number
  dealId: string
  dealRefetch: refetchFunc
}> = ({ plannedTurnoverDays, dealId, dealRefetch }) => {
  const { t } = useTranslation('deal')
  const { formProgress, formHandler } = useAFormHandler()

  const formik = useFormik({
    initialValues: {
      planned_turnover_days: null,
    },
    onSubmit: formHandler(async () => apiClient.post(endpoints.turnoverDaysSignature(dealId), formik.values), {
      onSuccess: dealRefetch,
    }),
  })

  if (!_.isNil(plannedTurnoverDays)) {
    return (
      <>
        <TextWrapper>
          <StatusDescription $isDone>
            {t('contractSign.status')} <AccentDescription $isDone>{t('contractSign.statusApproved')}</AccentDescription>
          </StatusDescription>
        </TextWrapper>
        <TextWrapper>
          <StatusDescription $isDone>
            {t('contractSign.turnoverPlan')}{' '}
            <AccentDescription $isDone>{t('contractSign.days', { count: plannedTurnoverDays })}</AccentDescription>
          </StatusDescription>
        </TextWrapper>
      </>
    )
  }

  return (
    <>
      <InputWrapper>
        <ShortFormControls>
          <FormInput
            label={t('contractSign.daysCount')}
            field="planned_turnover_days"
            formik={formik}
            size="small"
            type="number"
          />
        </ShortFormControls>
      </InputWrapper>
      <PermissionCheck scope={['deals.can_approve_planned_turnover_days']}>
        <AButton
          id="turnoverDaysSign"
          progress={formProgress}
          onClick={formik.submitForm}
          color="primary"
          size="medium"
        >
          {t('contractSign.approve')}
        </AButton>
      </PermissionCheck>
    </>
  )
}
